import type { PublicApiKey } from '#packages/apilib';
import type { createAccountApi } from './accountApi';

export const AccountApiKey: PublicApiKey<typeof createAccountApi> = {
  name: 'AccountApi',
  public: true,
};
